// Trusted contact — one pre-set person, saved privately on-device.
// Shape: { name, phone }
// by David Hunt

const STORAGE_KEY = "stillwater.trustedContact";

export const getTrustedContact = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const c = raw ? JSON.parse(raw) : null;
    return c && c.name && c.phone ? c : null;
  } catch (_) {
    return null;
  }
};

export const saveTrustedContact = (name, phone) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ name, phone }));
  } catch (_) {
    /* silent */
  }
};

export const clearTrustedContact = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (_) {
    /* silent */
  }
};

// Strip everything except digits and a leading + for tel:/sms: hrefs.
export const telHref = (phone) => `tel:${phone.replace(/[^\d+]/g, "")}`;
export const smsHref = (phone) => `sms:${phone.replace(/[^\d+]/g, "")}`;
